import styled from 'styled-components';
import Recruiting from "../../img/Recruiting.png"
const Main = styled.div`
    margin-top: 50px;
    background: white;
    text-align: center;
    padding-bottom: 50px;
`;

const ImageWrapper = styled.div`
    width: 100%;
    max-width: 800px;
    margin: 30px auto;
    padding: 0 20px;
`;

export default function Recruitment() {
    // 画像とPDFのパスをここに設定してください
    // publicフォルダに置くか、import文で読み込んでください
    const imageUrl = Recruiting; 
    const pdfUrl = "https://www.tosajuku.com/STEMON/Recruiting.pdf";

    return (
        <Main>
            <h2 className='pt-10 font-bold text-3xl text-blue-600'>求人情報</h2>

            <ImageWrapper>
                <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                    <img 
                        src={imageUrl} 
                        alt="求人情報チラシ" 
                        className="w-full shadow-lg hover:opacity-90 transition-opacity duration-300 border border-gray-200"
                    />
                </a>
            </ImageWrapper>
        </Main>
    );
}